import Start from './main/Start';

export default Start;
